import { render, staticRenderFns } from "./GoodDetails.vue?vue&type=template&id=3443b36d&scoped=true&"
import script from "./GoodDetails.vue?vue&type=script&lang=js&"
export * from "./GoodDetails.vue?vue&type=script&lang=js&"
import style0 from "./GoodDetails.vue?vue&type=style&index=0&id=3443b36d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3443b36d",
  null
  
)

export default component.exports